import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import URLUtils from '../../../util/URLUtils'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const ProjectCreateUI = ({context, messageList,
  // project type
  projectType, projectTypeList, onProjectTypeChange, projectTypeError,
  // project name
  projectName, onProjectNameChange, projectNameError, setProjectNameError,
  // short code
  shortCode, onShortCodeChange, shortCodeError, setShortCodeError,
  // template
  // when projectType=='template', "based on" is all projects+templates (projectList)
  // when projectType=='project', "based on" is only templates (templateList)
  templateId, templateList, projectList, onTemplateIdChange, templateIdError,
  // visibility
  visibility, visibilityList, onVisibilityChange, visibilityError,
  // project code
  projectCode, onProjectCodeChange, projectCodeError, setProjectCodeError,
  // description
  description, onDescriptionChange, descriptionError, setDescriptionError,
  // announcement
  announcement, onAnnouncementChange, announcementError, setAnnouncementError,
  // form
  onSubmit, submitted, successMsg, errorList, errorCode, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_create'
      onSubmit={onSubmit} busy={submitted}
      successMsg={successMsg} errorList={errorList} errorCode={errorCode} setErrorList={setErrorList}
    >
      <InputSelectUI name='projectType' value={projectType} required={true}
        messageList={messageList} labelKey='c_type'
        optionList={projectTypeList}
        onChange={onProjectTypeChange} error={projectTypeError}
      />
      <InputTextSF type='text' name='projectName' required={true} maxLength={100}
        messageList={messageList} labelKey={projectType === 'project' ? 'c_project_name' : 'c_template_name'}
        value={projectName} onChange={onProjectNameChange}
        error={projectNameError} setError={setProjectNameError}
        autoFocus={true}
      />
      <InputTextSF type='alphanumeric' name='shortCode' required={true} maxLength={5}
        messageList={messageList} labelKey='c_short_code' helpKey='c_shortcode_taskid_tip'
        value={shortCode} onChange={onShortCodeChange}
        error={shortCodeError} setError={setShortCodeError}
      />
      {
        ((projectType === 'project' && templateList.length > 1) || (projectType === 'template' && projectList.length > 1)) &&
        <InputSelectUI name='templateId' value={templateId} required={true}
          messageList={messageList} labelKey='c_based_on'
          optionList={projectType === 'project' ? templateList : projectList}
          onChange={onTemplateIdChange} error={templateIdError}
        />
      }
      <InputSelectUI name='visibility' value={visibility} required={true}
        messageList={messageList} labelKey='c_visibility'
        optionList={visibilityList}
        onChange={onVisibilityChange} error={visibilityError}
      />
      {
        visibility === 'all' &&
        <InputTextSF type='code' name='projectCode' required={true} maxLength={40}
          messageList={messageList} labelKey='c_sharable_name'
          help={`${URLUtils.getBaseURL()}/project/${projectCode}`}
          value={projectCode} onChange={onProjectCodeChange}
          error={projectCodeError} setError={setProjectCodeError}
        />
      }
    </FormSF>
  </CardUI>

  /*
  <InputTextSF type='text' name='description'
    messageList={messageList} labelKey='c_description' helpKey='c_prj_desc_tip'
    value={description} onChange={onDescriptionChange}
    error={descriptionError} setError={setDescriptionError}
  />
  <InputTextSF type='text' name='announcement' required={true}
    messageList={messageList} labelKey='c_announcement' helpKey='c_prj_announce_tip'
    value={announcement} onChange={onAnnouncementChange}
    error={announcementError} setError={setAnnouncementError}
  />
  */

export default ProjectCreateUI
